import React from 'react'
// import Carousel from 'react-material-ui-carousel'
// import img from './../assets/service/srv2.jpg'
import vid from "./../assets/Header/triller.mp4"
import { Box } from '@mui/material'

function SumServ() {
    return (
        <>
            {/* <!-- Simple video example -->
                <!-- 'Big Buck Bunny' licensed under CC 3.0 by the Blender foundation. Hosted by archive.org -->
                <!-- Poster from peach.blender.org --> */}
            {/* <video autoPlay muted src={vid} loop>
                Your browser does not support the video tag.
            </video> */}
            <Box className="header" mt={7} >
                <Box>
                    <Box className='videoBg' sx={{ display: 'flex', mt: '15px' }} >
                        <video autoPlay={true} muted src={vid} loop width={'90%'}>
                            Your browser does not support the video tag.
                        </video>
                    </Box>
                </Box>
            </Box>
            {/* <Carousel
                className={'animated fadeInDown delay-3s'}
                height={250}
                sx={{
                    marginTop: "25px",
                    width: { md: "50%", xs: "100%" },
                    margin: "auto"
                }}>
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
                <img
                    fetchpriority="high"
                    src={img}
                    alt=""
                    style={{
                        height: 250,
                        borderRadius: "20px",
                        width: "100%",
                        objectFit: "fill",
                    }}
                />
            </Carousel> */}
        </>
    )
}

export default SumServ